import './index.scss';
import React from 'react';
import Accordion from 'components/Accordion';
import useSaveFluxAutomaticPreference from 'utils/hooks/flux/automatic/useSaveFluxAutomaticPreference';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectFluxAutomaticLayoutCurrentTab,
} from 'redux/reducers/fluxAutomaticLayoutReducer';
import {
  setUnicenarioScenario,
  setRevisionDate,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';
import Button from 'components/DesignSystem/Button';
import { Stack } from 'react-bootstrap';
import ConfirmationModal from 'components/PreferenceDialog/Success';
import ErrorModal from 'components/PreferenceDialog/Error';
import AutomaticFrequentScenarios from './FrequentScenarios';
import AutomaticSavedPreferences from './SavedPreferences';
import AutomaticStudies from './AutomaticStudy';
import UnicenarioStudy from './UnicenarioStudy';
import VobsControlPanel from './VobsControlPanel';
import AutomaticControlPanelActions from './Actions';
import AcomphMLT from './AcomphMLT';
import PastSimulations from './PastSimulations';
import ClassicControlPanel from './ClassicControlPanel';
import SavePreferencesModal from './SavedPreferences/PreferenceSavingModal';

export default function ControlPanel() {
  const dispatch = useDispatch();
  const {
    showConfirmationModal,
    setShowConfirmationModal,
    showErrorModal,
    setShowErrorModal,
    error,
  } = useSaveFluxAutomaticPreference();
  const currentTab = useSelector(selectFluxAutomaticLayoutCurrentTab);

  const handleClearUnicenarioFilters = () => {
    dispatch(setUnicenarioScenario(undefined));
    dispatch(setRevisionDate(''));
  };

  return (
    <div>
      <ConfirmationModal
        open={showConfirmationModal}
        closing={() => { setShowConfirmationModal(false); }}
      />
      <ErrorModal
        open={showErrorModal}
        message={error?.data ?? ''}
        closing={() => { setShowErrorModal(false); }}
      />
      <SavePreferencesModal />
      {currentTab === 'classic' && <ClassicControlPanel />}
      {currentTab === 'vobs' && <VobsControlPanel />}
      {currentTab === 'unicenario' && (
        <>
          <Accordion defaultActiveKey="2">
            <UnicenarioStudy />
          </Accordion>
          <Stack className="pt-2">
            <div className="mx-auto">
              <Button
                type="tertiary"
                className="automatic-page-clear-filter-button mt-1"
                onClick={handleClearUnicenarioFilters}
              >
                Limpar filtros
              </Button>
            </div>
          </Stack>
        </>
      )}
      {currentTab !== 'classic' && currentTab !== 'unicenario' && currentTab !== 'vobs' && (
        <>
          <Accordion>
            <AutomaticFrequentScenarios />
            <AutomaticSavedPreferences />
            <AutomaticStudies />
            {currentTab !== 'revision' && (
              <>
                <AcomphMLT />
                <PastSimulations />
              </>
            )}
          </Accordion>
          <AutomaticControlPanelActions />
        </>
      )}
    </div>
  );
}
